import LocationsPanel from "@/panel/LocationsPanel";

export default function MyLocationPanel() {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <LocationsPanel />
    </div>
  );
}
